export default __webpack_public_path__ + "8fdf59cb2f258a0caade008af2b158a5.svg";